<div class="tab-data-container">
	@if (requestData.active === '1') {
		<div class="large-button" (click)="newCi.ciType === 'NEW' ? (newCi.ciType = '') : (newCi.ciType = 'NEW')">
			<span>{{ labels.lbl_cmdb_adicionar_cis_relacionados }}</span>
			<span [ngClass]="{ 'rotate-180': newCi.ciType !== 'NEW' }">
				<fa-icon [icon]="icons.faAngleDown"></fa-icon>
			</span>
		</div>
	}

	@if (newCi.ciType === 'NEW') {
		<div class="card-container">
			<pcp-cmdb-search-gadget
				[ignoreCiList]="bondedCisIdArr.join(',')"
				[allowedCiTypeList]="requestData.allowedCiTypes.join(',')"
				(getCi)="searchSelectedCi = $event; confirmCiBondModal.openModal()">
			</pcp-cmdb-search-gadget>
		</div>
	}

	@if (!requestData.relatedCis || requestData.relatedCis.length === 0) {
		<div class="card-container">
			{{ labels.lbl_no_related_ci }}
		</div>
	}

	@for (ci of requestData.relatedCis; track $index) {
		<div class="card-container">
			<div class="ci">
				<div>{{ ci.id }} {{ labels[ci.label_type] ? ' - ' + labels[ci.label_type] + ' - ' : ' - ' }} {{ ci.identification }}</div>
				<div>
					@if (requestData.active === '1') {
						<span (click)="openCiFieldEditor(ci)"><fa-icon [icon]="icons.faSquarePen"></fa-icon></span>
					}
					<span
						(click)="confirmUnbondCi.classList.contains('confirmClick') ? removeCi(ci) : confirmButton(confirmUnbondCi)"
						#confirmUnbondCi
						><fa-icon [icon]="icons.faTrash"></fa-icon
					></span>
					<a target="_blank" [routerLink]="'/cmdb/' + ci.id + '/read'">
						<fa-icon [icon]="icons.faExternalLinkAlt"></fa-icon>
					</a>
				</div>
			</div>
		</div>
	}
</div>

<cpi-modal [title]="labels.lbl_vincular_ci_chamado" #confirmCiBondModal>
	<ng-container body>
		<div class="button-container">
			<button (click)="confirmCiBondModal.closeModal()">{{ labels.lbl_geral_nao }}</button>
			<button (click)="bondCi(searchSelectedCi); confirmCiBondModal.closeModal()">{{ labels.lbl_geral_sim }}</button>
		</div>
	</ng-container>
</cpi-modal>

<cpi-modal [title]="'Editar campo do CI ' + (editingCi?.identification || '')" [showFooter]="true" #editCiFieldModal>
	<ng-container body>
		@if (isLoadingCiFields) {
			<div>Carregando campos...</div>
		} @else {
			<input type="search" [(ngModel)]="ciFieldSearch" placeholder="Pesquisar campo" />
			<select (change)="selectCiField($any($event.target).value ? filteredCiFields[$any($event.target).value] : undefined)">
				<option value="">Selecione um campo</option>
				@for (field of filteredCiFields; track field.name) {
					<option [value]="$index">{{ labels[field.label] || field.label || field.name }}</option>
				}
			</select>
			@if (selectedCiField) {
				<cpi-generic-form-gen [setGenericForm]="[selectedCiField]" [labels]="labels" [columns]="1"></cpi-generic-form-gen>
			}
		}
	</ng-container>
	<ng-container footer>
		<div class="button-container">
			<button (click)="editCiFieldModal.closeModal()" [disabled]="isSavingCiField">
				{{ labels.lbl_geral_cancelar || 'Cancelar' }}
			</button>
			<button (click)="saveCiField()" [disabled]="isSavingCiField || !selectedCiField">
				{{ labels.lbl_geral_atualizar || 'Atualizar' }}
			</button>
		</div>
	</ng-container>
</cpi-modal>

<cpi-modal
	[title]="labels.lbl_encontrados_chamados_mesma_classificacao_cis_relacionados"
	[showFooter]="true"
	(onModalClose)="relatedIncidentModal.closeModal()"
	#relatedIncidentModal>
	<ng-container body>
		@for (request of relatedIncident; track $index) {
			<div class="request-card" (click)="setRequestParent(request.id); relatedIncidentModal.closeModal()">
				<div class="dotted-input-container">
					<span>ID:</span>
					<span>{{ request.id }}</span>
				</div>
				<div class="dotted-input-container">
					<span>{{ labels.lbl_chamado_solicitacao }}:</span>
					<span>{{ request.summary }}</span>
				</div>
				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_descricao }}:</span>
					<span>{{ request.description }}</span>
				</div>
				<div class="dotted-input-container">
					<span>{{ labels.lbl_chamado_data_abertura }}:</span>
					<span>{{ request.open_date }}</span>
				</div>
			</div>
		}
	</ng-container>

	<ng-container footer>
		<div class="button-container">
			<button (click)="requestData.parent_request.id = undefined; relatedIncidentModal.closeModal()">
				{{ labels.lbl_estes_chamados_nao_estao_relacionados }}
			</button>
		</div>
	</ng-container>
</cpi-modal>
